/**
 * 门市模块接口
 * @description 门市列表、交易方式等门市相关接口
 */

import axios from "@/utils/request";
import Api from "../api";
import * as ResponseData from "../response.type";

/**
 * 获取门市列表
 */
export const Http_getStoresWithPermission = async () => {
  return await axios.get<ResponseData.StoreItem[]>(
    Api.GET_Stores_With_Permission
  );
};

/** 获取所有门市列表 */
export const Http_getAllStores = async () => {
  return await axios.get<ResponseData.StoreItem[]>(Api.GET_All_Stores);
};

/**
 * 根据用户ID查询门市列表
 * @param userId 用户ID
 * @returns 门市列表结果
 */
export const Http_getStoreByUserId = async (userId: string) => {
  return await axios.get(Api.GET_Store_Stores, {
    params: {
      userId,
    },
  });
};
